import { render, staticRenderFns } from "./Tabs.htm?vue&type=template&id=a5e1106a&scoped=true&"
import script from "./Tabs.ts?vue&type=script&lang=js&"
export * from "./Tabs.ts?vue&type=script&lang=js&"
import style0 from "./Tabs.scss?vue&type=style&index=0&id=a5e1106a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e1106a",
  null
  
)

export default component.exports